// © Microsoft Corporation. All rights reserved.

import { DesignSystem, isDarkMode, neutralForegroundHint, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../utils/enums";

const avatarSize = "54px";
const avatarSizeL0 = "78px"; // responsıve level 0
const sidePadding = "10px";
const buttonHeight = "36px";
const borderColor = "#DDDDDD";
const inReviewMarkColor = "#FFB900";
const notAllowMarkColor = "#E22C3B";
const markSize = 20;

export const ProfileCardStyles = (config: DesignSystem) =>  ({
    profileCardContainer: {
        position: "sticky",
        "z-index": "10",
        top: "123px",
        display: "flex",
        "flex-direction": "column",
        "align-items": "stretch",
        width: "calc(240px - 2 * " + sidePadding + ")",
        "min-width": "calc(240px - 2 * " + sidePadding + ")",
        margin: "3px",
        padding: "14px " + sidePadding + " 0",
        background: neutralLayerCard,
        color: neutralForegroundRest,
        "border-radius": "2px",
        "-webkit-box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",
        "-moz-box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",
        "box-shadow": "0px 0px 2.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)",

        "&.demo": {
            top: "0px"
        },

        "& .cwt-avatar-container": {
            position: "relative",
            "pointer-events": "none", // disables flash events

            "& .cwt-avatar": {
                "min-width": avatarSize,
                "max-width": avatarSize,
                height: avatarSize
            },

            "& .cwt-status-mark": {
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
                position: "absolute",
                bottom: (-markSize/4)+"px",
                [applyLocalizedProperty("right", "left", config.direction)]: (-markSize/4)+"px",
                width: markSize+"px",
                height: markSize+"px",
                color: "#FFFFFF",
                "border-radius": "50%",
                border: "2px solid ",
                "border-color": neutralLayerCard,

                "&.cwt-inreview": {
                    background: inReviewMarkColor // No fast Color available
                },

                "&.cwt-notallow": {
                    background: notAllowMarkColor // No fast Color available
                }
            }
        },

        "& .cwt-user-info ": {
            display: "flex",
            "flex-direction": "column",
            "align-items": "stretch",

            "& .cwt-user-header ": {
                display: "flex",
                "flex-direction": "column",
                "align-items": "center",
                "justify-content": "space-between",

                "& .cwt-name-title ": {
                    width: "100%",
                    "text-align": "center",

                    "& .cwt-name ": {
                        "margin-top": "5px",
                        "font-size": "24px",
                        "font-weight": "600"
                    }
                }
            }
        },

        "& .cwt-action-panel ": {
            margin: "0 -" + sidePadding,
            padding: ".75em",
            "border-top": "1px solid ",
            "border-color": borderColor,

            "& .cwt-edit-profile-btn.cwt-icon": {
                margin: ".175em .325em",
                "font-size": ".8em",
                color: neutralForegroundHint,

                "& .cwt-icon-label": {
                    color: isDarkMode(config) ? "#D9D9D9" : neutralForegroundHint
                }
            },

            "& .cwt-other-profile-settings": {
                display: "flex",
                "justify-content": "center",
                width: "100%",

                "& .cwt-fast-button": {
                    width: buttonHeight,
                    margin: "0 .175em",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                    "white-space": "nowrap",

                    "& .cwt-icon": {
                        "justify-content": "center"
                    }
                }
            }
        },

        /* RESPONSIVE CLASSES */
        ["&." + enums.responsiveLevels.L0]: {
            position: "static",
            width: "auto",
            "min-width": "calc(320px - 2 * " + sidePadding + ")",
            padding: "17px 10px 0",

            "& .cwt-avatar-container": {

                "& .cwt-avatar": {
                    "min-width": avatarSizeL0,
                    "max-width": avatarSizeL0,
                    height: avatarSizeL0
                }
            },

            "& .cwt-user-info": {
                "& .cwt-user-header": {
                    "flex-direction": "row",
                    "align-items": "flex-start",

                    "& .cwt-name-title": {
                        margin: "0 10px 0",
                        "text-align": "start",

                        "& .cwt-name": {
                            "margin-top": "0"
                        }
                    }
                }
            },

            "& .cwt-action-panel ": {
                border: "none",
                margin: "0 -18px",

                "& .cwt-other-profile-settings": {
                    "justify-content": "flex-start"
                }
            }
        }
    }
});